import React from 'react'
import { StyleSheet, View } from 'react-native'

import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'
import { PocketPickBackground as Background } from "@/components/Mini/Background"
import { PocketPickHeader as Header } from "@/components/Mini/Header"
import { PocketPickLogCard as LogCard } from "@/components/Mini/HistoryCard"


export const PocketPickLogScreen = () => {
  const handleClose = pocketPick.useHandleClose()

  return (
    <Background>
      <Header title="Your Stats" handler={handleClose} />
      <View style={styles.body}>
        <LogCard />
      </View>
    </Background>
  )
}

const styles = StyleSheet.create({
  fill: { flex: 1 },
  body: { flex: 1 }
})
